export enum TypeGraphEnum {
  Individuel,
  Collectif
}